import React from 'react';
import { robots } from '../config';

const RivalRobots: React.FC = () => {
  return (
    <div className="min-h-screen bg-transparent p-0 relative bg-gray-900">
      <div className="max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-auto p-8 md:p-12 lg:p-16 py-16 flex flex-col justify-start relative">
        {/* Header Section */}
        <div className="text-center mb-8 animate-fadeInUp">
          <div className="mb-6 flex justify-center">
            <a href="/" className="block transition-all duration-300 hover:scale-110">
              <img 
                src="/l5_simple.svg" 
                alt="Level 5 Robotics Logo"
                className="w-24 h-24 transition-all duration-300 object-contain"
              />
            </a>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 tracking-tight bg-gradient-to-r from-red-400 to-pink-400 bg-clip-text text-transparent">
            Rival Robots
          </h1>
          <p className="text-lg md:text-xl text-gray-300 mb-6 font-medium">Our Competition Robots</p>
        </div>

        {/* Robots Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-full">
          {robots.map((robot, index) => {
            const CardContent = () => (
              <div 
                className="bg-gray-800/90 border border-red-500/20 rounded-xl p-6 backdrop-blur-sm hover:bg-gray-700/90 hover:border-red-500/60 hover:-translate-y-1 hover:shadow-lg hover:shadow-red-500/30 transition-all duration-300 animate-fadeInUp"
                style={{ animationDelay: `${(index + 1) * 0.1}s` }}
              >
                {/* Robot Image */}
                <div className="mb-4 aspect-square bg-gray-700/50 rounded-lg overflow-hidden flex items-center justify-center">
                  {robot.imagePath ? (
                    <img 
                      src={robot.imagePath} 
                      alt={robot.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="text-gray-400 text-4xl">🤖</div>
                  )}
                </div>
                
                {/* Robot Info */}
                <div className="text-center">
                  <h3 className="text-xl md:text-2xl font-bold text-red-400/90 mb-2">{robot.name}</h3>
                  <p className="text-base md:text-lg text-gray-300 font-medium">{robot.season}</p>
                </div>
              </div>
            );

            if (robot.url) {
              return (
                <a 
                  key={index}
                  href={robot.url}
                  className="block text-inherit no-underline hover:no-underline"
                >
                  <CardContent />
                </a>
              );
            }

            return <CardContent key={index} />;
          })}
        </div>

        {/* Footer */}
        <div className="text-center mt-12 pt-8 border-t border-gray-600/30">
          <a href="/" className="text-gray-400 hover:text-white transition-colors duration-300">← Back to Level 5 Robotics</a>
        </div>
      </div>
    </div>
  );
};

export default RivalRobots;